module.exports = __webpack_public_path__ + "static/media/en.2aa3582f.svg";